import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { switchPage, fetchCommitteeDocuments } from '../actions';

class Pagination extends Component {

	constructor( props ) {
		super( props );
	}

	getPagination( pages ) {
		let arr = [];
		for ( let i = 0; i < pages; i++ ) {
			arr.push( i + 1 );
		}
		return arr;
	}

	goToPage( page ) {
		if ( typeof this.props.onClickFunc !== 'undefined' ) {
			this.props.onClickFunc( page );
		}
		this.props.switchPage( this.props.pageName, page );
	}

	createPaginationArr( current_page, last_page ) {
		let arr = [];
		if ( last_page < 5 ) {
			arr = Array( last_page - current_page + 1 ).fill()
			                                           .map( ( _, idx ) => current_page + idx );
		} else {
			for ( let j = 0; j < 4; j++ ) {
				if ( current_page === last_page && j < 4 ) {
					arr.push( current_page - (j + 1
					) );
				} else if ( current_page === last_page && j === 4 ) {
					break;
				} else {
					arr.push( current_page );
					current_page++;
				}
			}
		}
		if ( !arr.includes( last_page ) ) {
			arr.push( last_page );
		}
		if ( !arr.includes( 1 ) ) {
			arr.push( 1 );
		}

		return arr.sort( ( a, b ) => (last_page === current_page
		                             ) ? a - b : a - b );
	}

	getPaginationHTML( numberOfPages ) {
		let last_page = numberOfPages.length;
		let current_page = this.getCurrentPageNumber(last_page);
		let arr = this.createPaginationArr( current_page, last_page );
		let pagination_arr = [];
		for ( let index = 0; index < arr.length; index++ ) {
			let page = arr[ index ];
			let activePage = (page === current_page
			                 )
				? 'pagination-number  text-button active-page'
				: 'pagination-number text-button';
			if ( arr[ index - 1 ] === 1 && page - 1 !== arr[ index - 1 ] ) {
				pagination_arr.push( <span>...</span> );
				pagination_arr.push(
					<button className={ activePage } onClick={ this.goToPage.bind( this, page ) } type="button" >{ page }</button> );
				continue;
			}

			if ( page !== 1 && page !== last_page ) {

				if ( (((page + 1
				       ) !== arr[ index + 1 ]
				      ) || ((page - 1
				            ) !== arr[ index - 1 ]
				      )
				     ) && page !== current_page ) {
					pagination_arr.push( <span>...</span> );
					continue;
				}
			}
			pagination_arr.push(
				<button className={ activePage } onClick={ this.goToPage.bind( this, page ) } type="button" >{ page }</button> );
		}
		return pagination_arr;
	}

	getCurrentPageNumber(last_page) {
		let pageName = this.props.pageName;
		if ( typeof this.props.pagination[ pageName ] === 'undefined' ) {
			return 1;
		} else {
			let current_page = this.props.pagination[ pageName ];
			if ( last_page - current_page + 1 <= 0 ) {
				current_page = 1;
			}
			return current_page;
		}
	}

	getPaginationArrows( direction, current_page, last_page ) {
		if ( direction === 'left' ) {
			if ( current_page !== 1 ) {
				return (<Fragment>
						<button className={ 'text-button text-button-black' } type="button">
							<span onClick={ this.goToPage.bind( this, current_page - 1 ) } className="fa-solid fa-chevron-left" aria-hidden="true" />
						</button>
						<span className="sr-only">Go to Previous Page</span>

					</Fragment>
				);
			}
		} else {
			if ( current_page !== last_page.length  ) {
				return (<Fragment>
						<button className={ 'text-button text-button-black' } type="button">
							<span onClick={ this.goToPage.bind( this, current_page + 1 ) } className="fa-solid fa-chevron-right" aria-hidden="true" />
							<span className="sr-only">Go to Next Page</span>
						</button>
					</Fragment>
				);
			}
		}
	}

	render() {
		let itemsPerPage = this.props.itemsPerPage;
		let itemsLength = this.props.itemsLength;
		let pages = Math.ceil( itemsLength / itemsPerPage );
		let pagination = this.getPagination( pages );
		if ( itemsLength === 0 ) {
			return null;
		}
		return (
			<div className="pagination-container">
				{ pages > 1 && (this.getPaginationArrows( 'left', this.getCurrentPageNumber(pagination.length), pagination )
				) }
				{ this.getPaginationHTML( pagination ) }
				{ pages > 1 && (this.getPaginationArrows( 'right', this.getCurrentPageNumber(pagination.length), pagination )
				) }
			</div>
		);
	}

}

function mapStateToProps( { pagination } ) {
	return {
		pagination
	};
}

export default connect( mapStateToProps, {
	switchPage, fetchCommitteeDocuments
} )( Pagination );